import axios from "axios";
import { toast } from "react-toastify";
import store from "../Redux/Store";
import VerifyOtp from "../Login/VerifyOtp";

export default class ApiService {
    static getBaseUrl() {
        const currentDomain = window.location.origin;
        console.log('current domain', currentDomain)
        return currentDomain
    }

    static get baseUrl() {
        return ApiService.getBaseUrl() + '/'
    }

    static config = {
        // baseUrl: 'https://abnocloud.com/genesis_refresh_student_statement/api/',
        // baseUrl: 'https://abnocloud.com/genesis_unisol/',   //uat base url
        get baseUrl() { 
            return ApiService.baseUrl;
        },                                      //prod base url uncomment
        // baseUrl: 'https://abnocloud.com/lsk_prod/',
        // baseUrl: 'http://3.66.59.111/',
        // baseUrl: 'https://lskerp.lsk.or.ke/',        
        // baseUrl: 'https://online.lsk.or.ke/',
        // baseUrl: 'https://abnocloud.com/lsk_prod/business/',


        // baseUrl: 'http://localhost/project/genesis_unisol_website/',
        // baseUrl: 'http://localhost/genesis_unisol_website/',


        getBusinessTokenApi: 'get-business-token',

        getUtilitiesApi: 'get-member-utilities',

        getProfileDataApi: 'me',
        addAttachementApi: 'post-attachment',
        addEditNextOfKin: 'post-next-of-kin',

        checkEmailSendOtpApi: 'check-email-and-send-otp',
        VerifyOtpApi: 'verify-otp',

        memberBasicRegisterApi: 'member-registration',
        updateNextOfKinApi: 'update-next-of-kin',
        getMemberDetailApi: 'get-member-details',

        getStatementApi: 'get-statement',
        getReceiptApi: 'get-receipt',
        getInvoiceApi: 'get-invoices'
    }

    static async request(method, url, dataOrParams = {}, value = false) {
        try {
            const token = store?.getState()?.userData?.access_token
            const headers = {
                'Content-Type': 'application/json',
            };

            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            }

            if (dataOrParams instanceof FormData) {
                delete headers['Content-Type'];
            }

            const config = {
                method,
                // url: !value ? ApiService.config.baseUrl + url : ApiService.config.baseUrl + 'member/' + url,
                url: ApiService.config.baseUrl + 'api/' + 'member/' + url,
                headers: headers,
                timeout: 100000,
            };

            if (method === 'get' || method === 'delete') {
                config.params = dataOrParams;
            } else {
                config.data = dataOrParams;
            }

            const response = await axios(config);
            return response.data;
        } catch (error) {
            ApiService.handleError(error);
        }
    }

    static handleError(error) {
        if (error.response) {
            const errorData = error.response.data;
            toast.error(errorData.message || "Failed to process");
        } else if (error.request) {
            toast.error("No response received from server");
        } else if (error.code === 'ECONNABORTED') {
            toast.error("Request timed out");
        } else {
            toast.error("Failed to process");
        }
        console.error("API call failed:", error);
        throw error;
    }

    // Call api by some perticular methods also
    // static async get(url, params = {}) {
    //     try {
    //         const response = await axios.get(ApiService.config.url + url, {
    //             params,
    //         });
    //         return response.data;
    //     } catch (error) {
    //         ApiService.handleError(error);
    //     }
    // }

    // static async post(url, data = {}) {
    //     try {
    //         const headers = {
    //             'Content-Type': 'application/json',
    //         };

    //         // Add Authorization header if token is available
    //         // if (token) {
    //         //     headers['Authorization'] = `Bearer ${token}`;
    //         // }
    //         const response = await axios.post(ApiService.config.url + url, data, {
    //             headers: headers,
    //             timeout: ApiService.config.timeout,
    //         });
    //         return response.data;
    //     } catch (error) {
    //         ApiService.handleError(error);
    //     }
    // }

}